import React, { useState, useEffect } from 'react';
import { apiFetch} from "apiClient";
import { apiFetch as fetch } from "apiClient";


function Profile() {
    const [profile, setProfile] = useState(null);

    useEffect(() => {
        fetch(`/api/kite/profile`)
            .then(res => res.json())
            .then(data => setProfile(data))
            .catch(err => {
                console.error('Error fetching profile:', err);
            });
    }, []);


    return (
        <div>
            <h2>User Profile</h2>
            {profile ? (
                <div>
                    <p>Name: {profile.userName}</p>
                    <p>Email: {profile.email}</p>
                    {/* Add more profile fields as needed */}
                </div>
            ) : (
                <p>Loading...</p>
            )}
        </div>
    );
}

export default Profile;
